import React from 'react';
import { Contracts } from 'views';
import { Main } from 'layouts';
import WithLayout from 'WithLayout';

export default function ContractsPage(props: ViewComponentProps) {
	return <WithLayout component={Contracts} layout={Main} {...props} />;
}
